export default () => {
  return {
    accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.ROLLBAR_ENV,
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: process.env.REACT_APP_VERSION,
          guess_uncaught_frames: true,
        },
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/utils/rollbar.js